<template>
  <div>
    
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Add vendor</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Company Registration Number</b></p>
            <v-text-field outlined dense rounded type="text" v-model="company_reg_no"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Company Name</b></p>
            <v-text-field outlined dense rounded type="text" v-model="company_name"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="6" md="6">
            <p><v-icon color="error">*</v-icon><b>Company Address</b></p>
            <v-textarea label="Company Address" v-model="company_address" value placeholder="Enter Company Address"
              hint="Enter Company Address" outlined></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>GST Number</b></p>
            <v-text-field outlined dense rounded type="text" v-model="company_gst_no"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>TAN Number</b></p>
            <v-text-field outlined dense rounded type="text" v-model="company_tan_no"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>Contact Person Name</b></p>
            <v-text-field outlined dense rounded type="text" v-model="company_contact_person_name"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>Contact Person Contact No</b></p>
            <v-text-field outlined dense rounded type="text" v-model="company_contact_person_phone"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>Contact Person Email</b></p>
            <v-text-field outlined dense rounded type="text" v-model="company_contact_person_email"></v-text-field>
          </v-col>
        </v-row>


        <v-row justify="center" dense v-if="company_name && company_reg_no && company_address && company_gst_no">
          <v-btn color="warning" @click="saveInventoryInventoryVendor()" :loading="loader">Add</v-btn>
        </v-row>
      </v-card>

      <v-card class="box" v-if="inventory_vendor_list!='' ">
        <v-data-table :headers="headers" :items="inventory_vendor_list" :items-per-page="-1">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Inventory Vendor List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.isactive`]="{ item }">
            <v-switch v-model="item.isactive" @change="toggleIsactiveInventoryInventoryVendor(item)"
              :color="item.isactive ? 'success' : 'primary'"></v-switch>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red"
                @click="deleteInventoryInventoryVendor(item)">mdi-trash-can</v-icon>
            </v-avatar>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red" @click="editDetail(item)">mdi-pencil</v-icon>
            </v-avatar>
          </template>
          <template v-slot:[`item.islast`]="{ item }">
            <span v-if="item.islast">
              <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="dialog_edit" persistent scrollable="false" max-width="1200px"
        transition="dialog-bottom-transition">
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Material Specification</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <br>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><v-icon color="error">*</v-icon><b>Company Registration Number</b></p>
                <v-text-field outlined dense rounded type="text"
                  v-model="editedItem.company_registration_number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><v-icon color="error">*</v-icon><b>Company Name</b></p>
                <v-text-field outlined dense rounded type="text" v-model="editedItem.company_name"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="6" md="6">
                <p><v-icon color="error">*</v-icon><b>Company Address</b></p>
                <v-textarea label="Company Address" v-model="editedItem.address" value
                  placeholder="Enter Company Address" hint="Enter Company Address" outlined></v-textarea>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><v-icon color="error">*</v-icon><b>GST Number</b></p>
                <v-text-field outlined dense rounded type="text" v-model="editedItem.gst_no"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>TAN Number</b></p>
                <v-text-field outlined dense rounded type="text" v-model="editedItem.tan_no"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><b>Contact Person Name</b></p>
                <v-text-field outlined dense rounded type="text"
                  v-model="editedItem.contact_person_name"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Contact Person Contact No</b></p>
                <v-text-field outlined dense rounded type="text"
                  v-model="editedItem.contact_person_contact"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><b>Contact Person Email</b></p>
                <v-text-field outlined dense rounded type="text"
                  v-model="editedItem.company_contact_person_email"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveUpdateInventoryInventoryVendor()">Update</v-btn>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      inventory_vendor_list:[],
      company_reg_no:"",company_name:"",company_address:"",company_gst_no:"",company_tan_no:"",company_contact_person_name:"",company_contact_person_phone:"",company_contact_person_email:"",
      headers:[
      { text: "SR No", value: "srno" },
      { text: "Company Name", value: "company_name" },
      { text: "Company Registration Number", value: "company_registration_number" },
      { text: "Company Address", value: "address" },
      { text: "GST No", value: "gst_no" },
      { text: "TAN No", value: "tan_no" },
      { text: "Contact Person Name", value: "contact_person_name" },
      { text: "Contact Person Phone", value: "contact_person_contact" },
      { text: "Contact Person Email", value: "contact_person_email" },
      { text: "Is Active", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
      ],
      dialog_edit: false,
      extraBreadcrumbItems: [

      ],
      breadcrumbClass: "breadcrumb-style1",
    editedItem: {
      id: "",company_name:"",company_registration_number:"",address:"",gst_no:"",tan_no:"",contact_person_name:"",contact_person_contact:"",contact_person_email:""
    },
  }),
   methods: {
      clearData(){
        this.company_reg_no="",this.company_name="",this.company_address="",this.company_gst_no="",
        this.company_tan_no="", this.contact_person_name="", this.contact_person_contact="", this.contact_person_email=""
      },
      async saveUpdateInventoryInventoryVendor(){
       this.overlay = true;
       this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveUpdateInventoryInventoryVendor", this.editedItem);
          if (res.data.flag == "YES") {
            this.inventory_vendor_list=res.data.inventory_vendor_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar  
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
         this.dialog_edit = false;
      }
    },
    editDetail(item) {
      this.editedItem.id = item.id;
      this.editedItem.company_name = item.company_name;
      this.editedItem.company_registration_number = item.company_registration_number;
      this.editedItem.address = item.address;
      this.editedItem.gst_no = item.gst_no;
      this.editedItem.tan_no = item.tan_no;
      this.editedItem.contact_person_name = item.contact_person_name;
      this.editedItem.contact_person_contact = item.contact_person_contact;
      this.editedItem.contact_person_email = item.contact_person_email;
      this.dialog_edit = true;
    },
    async saveInventoryInventoryVendor(){
        const data = {
        company_name:this.company_name,
        company_registration_number:this.company_reg_no,
        address:this.company_address,
        gst_no:this.company_gst_no,
        tan_no:this.company_tan_no,
        contact_person_name:this.company_contact_person_name,
        contact_person_contact:this.company_contact_person_phone,
        contact_person_email:this.company_contact_person_email,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveInventoryInventoryVendor", data);
          if (res.data.flag == "YES") {
            this.inventory_vendor_list=res.data.inventory_vendor_list
            this.showSnackbar("green", "Saved Successfully"); // show snackbar   
            this.clearData();
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async toggleIsactiveInventoryInventoryVendor(item){
        const data = {
            id: item.id,
            isactive: item.isactive,
      };    
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/toggleIsactiveInventoryInventoryVendor", data);
          if (res.data.flag == "YES") {
             this.inventory_vendor_list=res.data.inventory_vendor_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar    
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async deleteInventoryInventoryVendor(item){
       if (!confirm("Are You Sure You Want To Delete This Item?"))
        return;
        const data = {
            id: item.id,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/deleteInventoryInventoryVendor", data);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Deleted Successfully"); // show snackbar    
             this.inventory_vendor_list=res.data.inventory_vendor_list
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
    async onLoad() {
      try {
          const res = await axios.post("/Inventory/getInventoryVendorList");
          if (res.data.flag == "YES") {
            this.inventory_vendor_list=res.data.inventory_vendor_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>